import styled from "styled-components"
import CustomBlockButton from "../../../../../components/button/CustomBlockButton"
import { CustomRatioImage } from "../../../../../components/image/CustomRatioImage"
import { useNavigate } from "react-router-dom"
import { useQueryParamsHook } from "../../../../../utils/useQueryParamsHook"
import { useEffect } from "react"
import { useSelectedCollectedOrderDataActionsContextHook, useSelectedCollectedOrderDataValueContextHook } from "../../contexts/SelectedCollectedOrderDataContext"

const StyledContainer = styled.nav`
    background-color: #ffffff;
    /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
    padding: 12px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    border-bottom: 1px solid #e0e0e0;
`

const StyledIconButton = styled(CustomBlockButton)`
    width: 40px;
    height: 40px;
    border: none;
    background-color: transparent;
    border-radius: 50%;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }

    .iconFigure {
        width: 24px;
        height: 24px;
        margin: auto;
    }
`

const StyledNavTitle = styled.h1`
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin: 0;
    flex-grow: 1;
    text-align: center;
`

const StyledFake = styled.div`
    width: 40px;
    height: 40px;
`

export function WegetViewTypeNav({ title }) {
    const navigate = useNavigate();
    const selectecCollectedOrderDataActionsContextHook = useSelectedCollectedOrderDataActionsContextHook();

    // 뷰 타입이 바뀌면 선택된 주문 데이터를 초기화
    useEffect(()=>{
        selectecCollectedOrderDataActionsContextHook.selectedCollectedOrderData.setValue(null);
    },[]);

    const handleMoveBack = () =>{
        navigate(-1);
    }

    return (
        <StyledContainer>
            <StyledIconButton onClick={() => handleMoveBack()}>
                <div className="iconFigure">
                    <CustomRatioImage>
                        <CustomRatioImage.Image src="/assets/icons/arrowBack_default_000000.svg" alt="Back" />
                    </CustomRatioImage>
                </div>
            </StyledIconButton>
            <StyledNavTitle>{title}</StyledNavTitle>
            <StyledFake />
        </StyledContainer>
    )
}

